import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox"]

  connect() {
    // console.log("SelectAllController connected!")
    // console.log("Checkbox targets found:", this.checkboxTargets.length)
  }

  toggle(event) {
    const checked = event.currentTarget.checked

    // Usa i target se Stimulus li ha trovati, altrimenti fallback sul DOM
    const boxes = this.hasCheckboxTarget 
      ? this.checkboxTargets 
      : this.element.querySelectorAll('[data-select-all-target="checkbox"]')

    boxes.forEach(cb => cb.checked = checked)
  }
}
